import { BoxGeometry, MeshStandardMaterial, TextureLoader } from 'three';
import { citySize } from 'constant/env';
import { useMemo } from 'react';
type Props = {
  selected: boolean;
};

export default function Ground({ selected }: Props) {
  const texture = useMemo(
    () => new TextureLoader().load('assets/env/road.png'),
    []
  );
  const geometry = new BoxGeometry(citySize, 1, citySize);
  const material = useMemo(
    () =>
      Array(6)
        .fill(null)
        .map((_, i) =>
          i === 2
            ? new MeshStandardMaterial({
                map: texture,
                transparent: true,
                opacity: selected ? 1 : 0.4,
              })
            : new MeshStandardMaterial({
                color: '#362616',
                roughness: 1,
                metalness: 0,
                transparent: true,
                opacity: selected ? 1 : 0.4,
              })
        ),
    [selected]
  );

  return (
    <mesh receiveShadow geometry={geometry} material={material}>
      <boxGeometry args={[citySize, 1, citySize]} />
    </mesh>
  );
}
